import { render, staticRenderFns } from "./AddEditAdminExamSettingsExaminers.vue?vue&type=template&id=3a0d67b3"
import script from "./AddEditAdminExamSettingsExaminers.vue?vue&type=script&lang=js"
export * from "./AddEditAdminExamSettingsExaminers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports